import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import {
  useApproveWithdrawalMutation,
  useCheckWithdrawalMutation,
  useDeclineWithdrawalMutation,
  useInProgressWithdrawalMutation,
} from '../store/withdrawals-api';

import type { TWithdrawalApproveParams, TWithdrawalDeclineParams, TWithdrawalInProgressParams } from '../store/types';

export const useWithdrawalStatus = () => {
  const [approveWithdrawal, {
    isLoading: isApproveLoading,
    isSuccess: isApproveSuccess,
    isError: isApproveError,
  }] = useApproveWithdrawalMutation();

  const [checkWithdrawal, {
    isLoading: isCheckLoading,
    isSuccess: isCheckSuccess,
    isError: isCheckError,
  }] = useCheckWithdrawalMutation();

  const [declineWithdrawal, {
    isLoading: isDeclineLoading,
    isSuccess: isDeclineSuccess,
    isError: isDeclineError,
  }] = useDeclineWithdrawalMutation();

  const [inProgressWithdrawal, {
    isLoading: isInPorgressLoaging,
    isSuccess: isInPorgressSuccess,
    isError: isInPorgressError,
  }] = useInProgressWithdrawalMutation();

  // Notifications
  useShowResponseStatus({
    isSuccess: isApproveSuccess || isDeclineSuccess || isInPorgressSuccess || isCheckSuccess,
    isError: isApproveError || isDeclineError || isInPorgressError || isCheckError,
  });

  // Handlers
  const handleApproveWithdrawal = (params: TWithdrawalApproveParams) => modals.openConfirmModal({
    title: 'Подтверждение вывода средств',
    centered: true,
    children: `Вы уверены, что хотите подтвердить вывод средств с ID ${params.withdrawalId}?`,
    labels: { confirm: 'Подтвердить вывод', cancel: 'Отменить' },
    onConfirm: async () => await approveWithdrawal(params),
  });

  const handleDeclineWithdrawal = (params: TWithdrawalDeclineParams) => modals.openConfirmModal({
    title: 'Отклонение вывода средств',
    centered: true,
    children: `Вы уверены, что хотите отклонить вывод средств с ID ${params.withdrawalId}?`,
    labels: { confirm: 'Отклонить вывод', cancel: 'Отменить' },
    confirmProps: { color: 'red' },
    onConfirm: async () => await declineWithdrawal(params),
  });

  const handleInProgressWithdrawal = (params: TWithdrawalInProgressParams) => modals.openConfirmModal({
    title: 'Подтверждение изменения статуса',
    centered: true,
    children: `Вы уверены, что хотите подтвердить изменение статуса "В работу" для с ID ${params.withdrawalId}?`,
    labels: { confirm: 'Добавить в работу', cancel: 'Отменить' },
    onConfirm: async () => await inProgressWithdrawal(params),
  });

  return {
    isApproveLoading,
    isDeclineLoading,
    isInPorgressLoaging,
    handleApproveWithdrawal,
    checkWithdrawal,
    isCheckLoading,
    handleDeclineWithdrawal,
    handleInProgressWithdrawal,
  };
};
